import { useEffect, useRef, useState } from "react"
import "./Toolbar.css"
import { TOOLTYPES } from "../Constants"
import ToolItem from "./ToolItem"

export default function Toolbar ({toolbarRef, color, setColor, toolType, setToolType, brushsize, setBrushsize, hotkeyPressed, setHotkeyPressed, onOpenBrushSlider}) {
    
    const colorInputRef = useRef()

    const toolAction = (type) => {
        setToolType(type)
    }

    return (
        <div className="toolbar"
            ref={toolbarRef}
        >
            <div className="tool-item active overflow-hidden">
                <input className="color-input" type="color" 
                    ref={colorInputRef}
                    value={color}
                    onChange={e => setColor(e.target.value)}
                    style={{background: color, color: color}}
                />
            </div>
            {TOOLTYPES.map(t => (<ToolItem
                key={t.type}
                icon={t.icon}
                type={t.type}
                active={toolType === t.type}
                toolAction={toolAction}
                setBrushsize={setBrushsize}
                hotkeyPressed={hotkeyPressed}
                hotkey={t.hotkey}
                setHotkeyPressed={setHotkeyPressed}
                onOpenBrushSlider={onOpenBrushSlider}
            />))}
        </div>
    )
}
